import UserDeviceList from '../container/deviceList/UserDeviceList';
function UserDeviceListPage() {
  return <UserDeviceList />;
}
export default UserDeviceListPage;
